import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

const KommuneLanding = props => {
  let seoImage = {
    src: "//ementodk.netlify.app/images/landing_pages/esundhed/esundhed-preview.jpg",
    width: 1566,
    height: 1154,
  }
  return (
    <Layout location={props.location} title="Kommune" locale="da-dk">
      <Seo
        image={seoImage}
        title="Når du guider borgeren derhjemme, forkorter du forløbet"
        lang="da-DK"
        pathname="kommune"
      />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner grid gap kommune">
            <div className="landing-hero">
              <div className="landing-hero-pre">Forløbsguides i kommunen</div>
              <h1>Når du guider borgeren derhjemme, forkorter du forløbet</h1>
            </div>
            <div className="landing-3col-kommune">
              <div className="landing-3col-item">
                <div className="landing-3col-item-content">
                  <h3>
                    Færre udeblivelser og aflysninger er mærkbare gevinster
                  </h3>
                  <p>
                    Men Forløbsguiden understøttes tusindsvis af borgere i dag i
                    deres forløb med kommunen. Det gavner den enkelte borger,
                    frontlinjemedarbejderen og kommunen.
                  </p>
                  <div className="landing-3col-item-description">
                    (Tal stammer fra en kommune, der bruger Forløbsguiden fra
                    Emento)
                  </div>
                </div>
              </div>
              <div className="landing-box numbers-wide">
                <div className="landing-box-numbers  bg-dark-red">
                  <h2 className="fg-pink">38%</h2>
                  <p className="fg-pink">færre aflysninger</p>
                </div>
              </div>
              <div className="landing-box numbers-narrow">
                <div className="landing-box-numbers  bg-purple">
                  <h2 className="fg-green">29%</h2>
                  <p className="fg-green">færre udeblivelser</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wide-container bg-pink landing-wide-quote">
          <div className="wide-inner kommune">
            <div className="landing-2col landing-image-quote">
              <div className="landing-image-quote-image">
                <img
                  src="/images/landing_pages/kommune/line_engel.jpg"
                  alt="Line Rosenørn Engel"
                />
              </div>
              <div className="landing-image-quote-content">
                <h4>
                  "Bliver vi hurtigere 'færdige' med borgerne; det er jo dér, at
                  vi kan se, at besparelserne i sidste ende ligger.
                </h4>
                <p>
                  Line Rosenørn Engel, specialkonsulent, Børn & Unge, Københavns
                  Kommune
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="wide-container">
          <div className="wide-inner kommune">
            <div className="landing-3col-kommune align-bottom">
              <div className="landing-3col-item ">
                <div className="landing-3col-item-content">
                  <h3>Øget behandlingseffekt, når borgere guides</h3>
                  <p>
                    En forløbsguide hjælper borgeren til at mestre sit forløb og
                    de planlagte indsatser på en meningsfuld, temposkabende og
                    menneskelig måde - uden at den faglige kvalitet forringes.
                  </p>
                  <div className="landing-3col-item-description">
                    (Tal stammer fra en kommune, der bruger Forløbsguiden fra
                    Emento)
                  </div>
                </div>
              </div>
              <div className="landing-box numbers-narrow">
                <div className="landing-box-numbers  bg-khaki">
                  <h2 className="fg-blue">1 md</h2>
                  <p className="fg-blue">
                    kortere
                    <br />
                    psyk-behandling
                  </p>
                </div>
              </div>
              <div className="landing-box numbers-wide">
                <div className="landing-box-numbers  bg-orange">
                  <h2 className="fg-pink">1,5 mdr</h2>
                  <p className="fg-pink">
                    kortere
                    <br />
                    kontaktperson-forløb
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-case-image-bg">
          <div className="landing-case-image-bg-container">
            <h2>
              Et forløb er den rigtige information på det rigtige tidspunkt
            </h2>
          </div>
          <div className="wide-container">
            <div className="wide-inner trust grid gap kommune">
              <div className="landing-case-image-bg-content">
                <div className="landing-case-image-bg-content-title">Case</div>
                <div className="landing-case-image-bg-content-link">
                  Lær hvordan Københavns Kommune rammesætter forløb
                  <br />
                  <a
                    href="/cases/bbu-rammesaetter-forlob-for-borgeren-med-forlobsguiden/"
                    className="button"
                  >
                    Se case
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-video">
          <div className="landing-video-player">
            <video
              width="275"
              height="600"
              loop="loop"
              autoPlay="autoplay"
              playsInline="playsinline"
              preload="none"
              muted
            >
              <source
                src="//videos.ctfassets.net/8eaotls8wqkz/3JJBgblmz3V8Ddw5gQ6wxb/17f2ce15ad0ab5c2eaf9834d496d4097/emento_screen_kommune.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <div className="wide-container">
            <div className="wide-inner trust grid gap kommune">
              <div className="landing-video-info">Hvad borgeren ser</div>
            </div>
          </div>
        </div>
        <div className="wide-container">
          <div className="wide-inner trust grid gap kommune">
            <div className="landing-contact landing-2col">
              <div className="landing-contact-text">
                Kom hurtigt og nemt i gang med vores start-pakke.{" "}
                <span className="fg-khaki">Kontakt os for at høre mere</span>
              </div>
              <div className="landing-contact-images">
                <div className="landing-contact-person">
                  <a
                    href="mailto:allan@emento.dk"
                    className="landing-contact-person"
                  >
                    <img
                      src="/images/portraits/2022/allan.jpg"
                      alt="Allan Juhl, Emento"
                    />
                    <div className="landing-contact-person-details">
                      <b>Allan Juhl</b>
                      <p>CEO</p>
                    </div>
                  </a>
                  <div className="landing-contact-info">
                    <a href="mailto:allan@emento.dk">Email</a>
                    <a href="tel:+22599023">Telefon</a>
                  </div>
                </div>
                <div className="landing-contact-person">
                  <a
                    href="mailto:morten@emento.dk"
                    className="landing-contact-person"
                  >
                    <img
                      src="/images/portraits/2022/morten.jpg"
                      alt="Morten Rask Thomsen, Emento"
                    />
                    <div className="landing-contact-person-details">
                      <b>Morten Rask Thomsen</b>
                      <p>Relationship Manager</p>
                    </div>
                  </a>
                  <div className="landing-contact-info">
                    <a href="mailto:allan@emento.dk">Email</a>
                    <a href="tel:+30373311">Telefon</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default KommuneLanding
